module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "FRONTMATTER"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpro"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_c('i', [_vm._v("“Ronnie turned that torch over to Newt and the Republican members of Congress to keep that dream alive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("merican history has the almost supernatural habit of mirroring itself. Thomas Jefferson and John Adams died on the same day exactly fifty years after adopting the Declaration of Independence. The Civil War began and ended on the same man’s property. And the two most important intellectual revolutions in this country took place in the same decade, the ’70s—separated by exactly two hundred years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just as the American Revolution was a conservative one—unlike the French Revolution and the Russian Revolution, as every schoolchild used to be taught—a second conservative revolution took place in the 1970s, once again challenging dictatorial and big, corrupt government with new ideas and a renewed vigor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("American conservatism is a truly unique and singular philosophy in the world, vastly different from British conservatism. American conservatism takes its inspiration from John Locke, Thomas Paine, Thomas Jefferson, the Declaration of Independence, and the Constitution, and believes that the individual bearing God’s image is at the center of creation because God wants him there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("American conservatism stands in stark contrast to that of Edmund Burke, the father of British conservatism, who believed in the divine right of kings and that power flowed downward from London and the British Empire to the people rather than the reverse, as the American expression holds. The distinction is crucial, and only the mistaken claim that Burke is the father of American conservatism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  }, [_vm._v("Despite being a mostly dark tale, the 1970s saw the rise and rebirth of modern American conservatism, which came to full fruition less than ten years later. Thereafter, American conservatism quite literally changed America and changed the world by spreading rock-solid beliefs such as freedom was good. Godless Communism was bad. More was generally better than less. A Judeo-Christian heritage is better than atheism, because faith teaches us about mercy, love, understanding, and forgiveness. And, finally, winning is better than losing. All these precepts came alive again beginning in the 1970s, after a long, rationally draining era, most especially the drug-addled 1960s.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The explosion of creative thought in American conservatism in the 1970s centered on the expansion of freedom for the individual while pushing back on the illicit authority of the State. It was the first time serious attempts were made to create arguments against the New Deal, the New Frontier, and the Great Society. Conservatives defeated the idea of corrupt collectivism with the superior argument of maximum freedom to the states, localities, and individuals, consistent with law and order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, all this would have been irrelevant without dynamic leadership giving voice to rising conservatism, and there are none more important than Ronald Reagan, and few more important than Newt Gingrich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ronald Reagan’s place in history is secure, notwithstanding liberal attempts to mischaracterize, hijack, or write poorly researched books about him. There have been some fine books written about President Reagan, but there have been few about Gingrich that are honest and accurate, though many have been written. Most books about Gingrich have been deeply flawed, biased, and downright hostile. The preservation of honest, fact-based, and objective history is too important to be left to people with more interest in an agenda than the facts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Citizen Newt")]), _vm._v(" takes the reader from the threadbare days of his early and failing campaigns for Congress to his startling election in 1978 and his steady but sure climb up the ladder in the leadership of the GOP and the leadership of the conservative movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This volume is the only factual account of the twenty-year rise of a first generation Reaganite. Operationally, wrote respected Democratic pollster John Zogby, what Bill Buckley was to scholarly conservatism, what Reagan was to the leadership of conservatism, what Antonin Scalia was to the legal "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "title": "xvii"
    }
  }, [_vm._v("arguments of conservatism, Newt Gingrich was to its tactical and legislative and political successes. Nancy Reagan once said that Gingrich helped complete the Reagan Revolution, that “Ronnie turned that torch over to Newt and the Republican members of Congress to keep that dream alive.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9781595554499_Notes#cp_rfn1",
      "id": "cp_fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" That makes Gingrich and—it is to be hoped—this book important.")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract8"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Craig Shirley")]), _vm._v(" "), _c('p', {
    staticClass: "extract8"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Ben Lomond, Virginia")]), _vm._v(" "), _c('p', {
    staticClass: "extract8"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("2016")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-171f224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9781595554499_Prologue.vue
// module id = 81
// module chunks = 0